import React from 'react';
import styled from 'styled-components';
import MotifChip from '@ey/motif-react-wrapper/Chip';

export default function Chip(props) {
	const {
		id,
		className,
		title,
		type,
		variant,
		disabled,
		removable,
		trigger,
		placement,
		closeButtonProps,
		onClick,
		onRemove,
		label,
		leftIcon,
		icon,
		dropdown
	} = props;
	return (
		<StyledMotifChip
			id={id}
			className={className}
			title={title}
			type={type}
			variant={variant}
			disabled={disabled}
			removable={removable}
			trigger={trigger}
			placement={placement}
			closeButtonProps={closeButtonProps}
			onClick={onClick}
			onRemove={onRemove}
			dropdown={dropdown}
		>
			{leftIcon && icon}
			{label}
		</StyledMotifChip>
	);
}

const StyledMotifChip = styled(MotifChip)``;
